export default {
    elearncategory:{},
    elearncategoryData : [],
    categoryList: [],
}